import TrashIcon from "assets/icons/TrashIcon";
import BasicButton from "components/BasicInputs/BasicButton";
import BasicSelect from "components/BasicInputs/BasicSelect";
import RenderInput from "components/BasicInputs/RenderInput";
import { ReactNode, useEffect, useState } from "react";
import Icon from "../../Shared/atoms/Icon";
import { formatPrice } from "helpers";
import EditIcon from "assets/icons/EditIcon";
import HashtagIcon from "assets/icons/Hashtag";
import PlusIcon from "assets/icons/PlusIcon";
import MinusIcon from "assets/icons/MinusIcon";
export interface CardProps {
  onChange?: (data: { val: any; key: any; option?: any }) => void;
  onTypeChange?: (val: any, option: any) => void;
  onDelete?: (index: number) => void;
  extraFooterBtn?: ReactNode
  index?: number;
  type?: string;
  forceType?: string;
  defPrice?: number;
  currency?: Currency;
  options?: { label: string; value: string; icon: string; active?: boolean }[];
  inputs?: { [key: string]: FormInput };
  inputsToShow?: any;
  data: any;
  edit?: boolean;
  onChangeEdit?: (edit: boolean) => void;
  info?: { icon: string; title: any; dsc: any; price: number; ind: string; isPositive?: boolean };
  justShow?: boolean;
}
export default function Card(props: CardProps) {
  const { inputs, data, info, extraFooterBtn } = props;
  const [edit, setEdit] = useState(props.edit);
  useEffect(() => setEdit(props.edit), [props.edit]);
  if (props.justShow && info) {
    const { icon, price, title, ind, isPositive } = info;
    return (
      <div className="bg-light-2 p-3 flex flex-col gap-3 rounded-md">
        <div className="flex items-center gap-2">
          <Icon url={icon} rounded />
          <div>{ind}</div>
          <div className="w-4 h-4 bg-light-3 rounded-md flex items-center justify-center">
            <HashtagIcon style={{ transform: "scale(0.7)" }} />
          </div>
          <span>-</span>
          <span>{title}</span>
        </div>
        <div className="flex flex-row-reverse items-center gap-2">
          <span className="text-dark-3">{props.currency?.en_title}</span>
          <span className="text-lg">{price}</span>
          <span>
            {isPositive ? <PlusIcon color="green" scale={0.7} /> : <MinusIcon color="red" scale={0.7} />}
          </span>
        </div>
      </div>
    );
  }

  if (!edit && info) {
    const { dsc, icon, price, title, ind } = info;
    return (
      <div className="px-8 py-4 flex flex-col gap-4 border border-slate-100 rounded-md animate-slide-in-top relative">
        {props.index !== undefined && (
          <span className="text-gray-400 text-base font-bold absolute top-4 right-4">{props.index + 1}</span>
        )}
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div className="flex items-center gap-2">
            <Icon url={icon} />
            <div className="flex items-center gap-2">
              <span className="text-[25px] text-dark-1">{formatPrice(price)}</span>
              <span className="text-dark-3">{props.currency?.en_title}</span>
            </div>
          </div>
          <div>{dsc}</div>
        </div>
        <div>
          <div className="flex items-center gap-2">
            {ind && (
              <div className="flex items-center gap-2">
                <span className="text-xl">{ind}</span>
                <div className="w-6 h-6 bg-light-3 rounded-[4px] flex items-center justify-center">
                  <HashtagIcon color="#6B7888" />
                </div>
                <span>-</span>
              </div>
            )}
            <span className="text-lg">{title}</span>
          </div>
        </div>
        <div className="flex items-center">
          <div>
            <BasicButton
              color="disabled"
              className="justify-start min-w-[100px]"
              onClick={() => {
                setEdit(true);
                props.onChangeEdit && props.onChangeEdit(true);
              }}
            >
              <EditIcon color="#6B7888" style={{ transform: "scale(1)" }} />
              <span className="text-sm">ویرایش</span>
            </BasicButton>
            {extraFooterBtn && extraFooterBtn}
          </div>
          {props.onDelete && (
            <div>
              <BasicButton
                color="disabled"
                className="justify-start min-w-[100px]"
                onClick={() => props.onDelete && props.onDelete(props.index || 0)}
              >
                <TrashIcon color="#6B7888" style={{ transform: "scale(1)" }} />
                <span className="text-sm">حذف</span>
              </BasicButton>
            </div>
          )}
        </div>
      </div>
    );
  }
  return (
    <div className="py-4 px-8 bg-gray-100 rounded-md flex flex-col gap-4 animate-slide-in-bottom">
      <div className="flex gap-4 items-center">
        {props.index !== undefined && (
          <span className="text-blue-1 text-lg font-bold">{props.index + 1}</span>
        )}
        <BasicSelect
          options={props.options?.filter((x) => (x.active !== undefined ? x.active : true))}
          onChange={(val, option) => props.onTypeChange && props.onTypeChange(val, option)}
          preferences={{ button: 2 }}
          menuStyle={{ minWidth: 300 }}
          noVirtual
          defaultValue={props.forceType || props.type}
          disabled={!!props.forceType}
        />
      </div>
      {inputs &&
        Object.keys(inputs)
          .filter((x) => props.inputsToShow[props.type || ""]?.includes(x))
          .map((x, index) => {
            let input = inputs[x];

            if (input.type === "inline") {
              input.inputs = input.inputs?.map((y) => ({
                ...y,
                onChange: (val) => props.onChange && props.onChange({ val, key: y.name }),
              }));
            }
            return (
              <RenderInput
                key={index}
                onChange={(val, option) => props.onChange && props.onChange({ val, key: x, option })}
                onClear={() => props.onChange && props.onChange({ val: undefined, key: x })}
                withClear
                val={data[x]}
                defaultValue={data[x]}
                defaultValues={[data[x]]}
                {...input}
              />
            );
          })}
      {props.onDelete && (
        <div>
          <BasicButton
            color="disabled"
            className="justify-start"
            onClick={() => props.onDelete && props.onDelete(props.index || 0)}
          >
            <TrashIcon color="#6B7888" />
            <span>حذف</span>
          </BasicButton>
          {extraFooterBtn && extraFooterBtn}
        </div>
      )}
    </div>
  );
}
